(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["qi-snow"] && !Shopify.designMode) return;
  try {
    
class Snow extends window.HTMLElement {
  constructor() {
    super();
    this.img = this.getAttribute("img");
    this.snowNum = this.getAttribute("snowNum");
    this.canvas = null;
    this.animationFrame = null;
    this.init();
    this.handleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.handleResize);
  }

  init() {
    if (this.canvas) {
      cancelAnimationFrame(this.animationFrame);
      document.body.removeChild(this.canvas);
    }
    const canvas = document.createElement("canvas");
    canvas.setAttribute("id", "snow");
    canvas.style.position = "fixed";
    canvas.style.top = "0";
    canvas.style.width = "100vw";
    canvas.style.height = "100vh";
    canvas.style.zIndex = "100";
    canvas.style.pointerEvents = "none";
    document.body.appendChild(canvas);
    this.canvas = canvas;
    const W = canvas.clientWidth;
    const H = canvas.clientHeight;
    canvas.setAttribute("width", W);
    canvas.setAttribute("height", H);
    const ctx = canvas.getContext("2d");
    const config = {
      // 基础雪花数量 + 根据amount增加的密度
      baseCount: Math.ceil(W * H / 15000),
      snowArr: [],
      pic: this.img,
      amountScale: this.snowNum / 100 // 将amount转换为0-1的缩放系数
    };
    
    // 计算最终雪花数量
    const totalCount = Math.min(
      Math.ceil(config.baseCount * (1 + config.amountScale * 3)), // 最大不超过基础值的4倍
      Math.ceil(W * H / 3000) // 每3000像素一个雪花的密度上限
    );
    
    // 等待图片加载完成
    const snowImg = new Image();
    snowImg.onload = () => {
      for (let i = 0; i < totalCount; i++) {
        config.snowArr.push({
          x: Math.random() * W,
          y: -50 - Math.random() * 100, // 从顶部开始
          vx: (Math.random() - 0.5) * 2, // 水平速度范围-1到1
          vy: Math.random() * 0.5 + 0.3 + i * 0.005, // 垂直速度
          size: Math.random() * 8 + 2, // 大小范围2-10px
          img: snowImg, // 使用加载的图片
          opacity: Math.random() * 0.5 + 0.5 // 透明度
        });
      }
      this.startAnimation(ctx, W, H, config);
    };
    snowImg.src = config.pic;
  }

  startAnimation(ctx, W, H, config) {
    const dropAnimation = () => {
      ctx.clearRect(0, 0, W, H);
      for (let i = 0; i < config.snowArr.length; i++) {
        let snow = config.snowArr[i];
        // 绘制雪花
        ctx.globalAlpha = snow.opacity;
        ctx.drawImage(snow.img, snow.x, snow.y, snow.size, snow.size);
        ctx.globalAlpha = 1;
        
        // 更新位置
        snow.x += snow.vx;
        snow.y += snow.vy;
        
        // 边界处理
        if (snow.x > W + snow.size) snow.x = -snow.size;
        if (snow.y > H + snow.size) {
          snow.y = -50 - Math.random() * 100;
          snow.x = Math.random() * W;
          snow.vx = (Math.random() - 0.5) * 2;
          snow.vy = Math.random() * 0.5 + 0.3 + i * 0.005;
        }
      }
      this.animationFrame = requestAnimationFrame(dropAnimation);
    };
    this.animationFrame = requestAnimationFrame(dropAnimation);
  }

  handleResize() {
    this.init();
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
    if (this.canvas && this.canvas.parentElement) {
      document.body.removeChild(this.canvas);
    }
  }
}

// 确保自定义元素名称一致
if (!customElements.get("ql-snow")) {
  window.customElements.define("ql-snow", Snow);
}

  } catch(e) { console.error(e); }
})();
})();
